import { useLazyQuery } from '@apollo/client'
import { GET_PRODUCTS_CUSTOM_LIST } from '@services/api/graphql/queries/getProductsCustomList'

export const useProductsCustomList = () => {
  const [getProductsCustomList, { data, loading, error, variables, called }] =
    useLazyQuery(GET_PRODUCTS_CUSTOM_LIST)

  return { getProductsCustomList, data, loading, error, variables, called }
}
